import { HTTP_CLIENT } from '@common/clients/http/http.client.interface';
import { container } from 'tsyringe';
import masterRepositoryImpl from './repositories/master.repository.impl';
import IMasterRepository from './repositories/master.repository.interface';

// INFRASTRUCTURE
const httpClient = container.resolve(HTTP_CLIENT);

// REPOSITORIES
const masterRepository = container
  .register<IMasterRepository>('MasterRepository', {
    useValue: masterRepositoryImpl(httpClient),
  })
  .resolve<IMasterRepository>('MasterRepository');

export default masterRepository;
